import React, { useEffect, useState } from 'react';
import Completed from './assets/icon-completed.svg';
import Close from './assets/icon-close.svg';
import uniqueId from 'lodash/uniqueId';
import filesize from 'filesize';
import Axios from 'axios';
import './upload-progress.scss';
import { DocumentUploadS3 } from 'generated/credit-analysis-graphql';

export type DocumentFile = {
   id: string;
   name: string;
   size: string;
   progress: number;
   completed: boolean;
}

type UploadItemProps = {
   documentFile: File;
   onComplete(): void;
   onError(): void;
   getSignedUrl(filename: string, contentType: string): Promise<DocumentUploadS3>;
};

const UploadItem: React.FC<UploadItemProps> = ({ documentFile, getSignedUrl, onComplete, onError }): JSX.Element => {
   const [source] = useState(Axios.CancelToken.source());
   const [data, setData] = useState<DocumentFile>({
      id: uniqueId(),
      name: documentFile.name,
      progress: 0,
      size: filesize(documentFile.size),
      completed: false,
   });

   const upload = async () => {
      try {
         const response = await getSignedUrl(documentFile.name, documentFile.type);
         await Axios.put(response.url, documentFile, {
            headers: {
               'Content-Type': documentFile.type,
               'x-amz-meta-data': response.data,
            },
            cancelToken: source.token,
            onUploadProgress: ({ loaded, total }: ProgressEvent) => {
               const progress = Math.round((loaded / total) * 100);
               const completed = progress === 100;

               setData({ ...data, progress, completed });
            },
         });

         onComplete();
      } catch (error) {
         if (Axios.isCancel(error)) {
            onError();
         } else {
            alert('Ocorreu um erro durante o upload. Se o erro persistir entre em contato conosco.');
         }
      }
   }

   useEffect(() => {
      upload();
   }, []);

   if (data.completed) {
      return (
         <div className="c-progress-upload c-progress-upload--completed">
            <div className="c-progress-upload__title body-2">{data.name}</div>
            <div className="c-progress-upload__size overline">{data.size}</div>
            <div className="c-progress-upload__actions">
               <span><img src={Completed} /></span>
            </div>
         </div>
      )
   }

   return (
      <div className="c-progress-upload">
         <div className="c-progress-upload__title body-2">{data.name}</div>
         <div className="c-progress-upload__value overline">{data.progress}%</div>
         <div className="c-progress-upload__bar">
            <div className="c-progress-upload__bar__status" style={{ width: `${data.progress}%` }} />
         </div>
         <div className="c-progress-upload__actions">
            <button type="button" onClick={() => source.cancel()}>
               <img src={Close} />
            </button>
         </div>
      </div>
   );
};

export default UploadItem;
